import http from "@/apps/shared/baseService/config";

class Service {
  list() {
    return http.post("/user/descountcoupon/list");
  }
}

export default new Service();
